import { createUseInfiniteQueryHook } from 'hooks/createUseInfiniteQueryHook';

export const useGroupAvailablePersonsInfinite = createUseInfiniteQueryHook('get_available_persons', {
    cacheTime: Infinity,
});
